import { Observable } from 'rxjs';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apis, controllerTypes, HttpRequestSettings } from '@sb-shared/models/request-settings';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActivationService {
    
  config: HttpRequestSettings = {
    controllerType: controllerTypes.User,
    api: apis.Core,
    shareReplay: 1
  };

  constructor(private http: HttpWebApiService, private originalHttp: HttpClient) {}

  QueueWelcomeCommunication(organisationId: number, isWelcome: boolean, email: string): Observable<any> {
    return this.http.get('Communication/QueueWelcomeCommunication', {...this.config, params: { email, isWelcome, organisationId }});
  }

  QueuePasswordResetCommunication(organisationId: string, email: string): Observable<any> {
    return this.http.get('Communication/QueuePasswordResetCommunication', {
      ...this.config,
      params: { email, organisationId },
      fullResponse: true
    })
  }

  ValidateResetToken(email: string, token: string): Observable<any> {
    return this.originalHttp.post(`${environment.idUrl}/api/User/ValidateResetToken`, { email, token });
  }

  ResetPassword(email: string, password: string, token: string): Observable<any> {
    return this.originalHttp.post(`${environment.idUrl}/api/User/ResetPassword`, {email, password, token });
  }
}
